/**
 * Mock contact titles for demo mode.
 * Mirrors the canonical ContactTitles lookup seeded in the database.
 */
export const mockContactTitleOptions: string[] = ['Mr.', 'Mrs.', 'Ms.', 'Miss', 'Dr.', 'Prof.', 'Rev.'];
